module.exports = __webpack_public_path__ + "img/investigation-dd-l1.a0fbfd76.svg";